import {
  LOADING_WBS,
  SUCCESS_GET_WBS,
  ERROR_GET_WBS,
  CLEARREPORT,
} from "./wbsTypes";
import axios from "axios";

const loadingActionHelper = () => {
  return {
    type: LOADING_WBS,
  };
};
const successWBSActionHelper = data => {
  return {
    type: SUCCESS_GET_WBS,
    payload: data,
  };
};
const errorActionHelper = error => {
  return {
    type: ERROR_GET_WBS,
    error,
  };
};
export const clearReport = () => async dispatch => {
  try {
    dispatch({
      type: CLEARREPORT,
    });
  } catch (error) {}
};
export const getWbs = (filterArr, sDate, eDate) => async dispatch => {
  dispatch(loadingActionHelper());
  //
  try {
    const subprojectId = global.config.secureStorage.getItem("subprojectId");
    const superproject = global.config.secureStorage.getItem("superproject");

    var getProjectIds = await axios.get(
      `${global.config.backendURL}/wbs/getProjectIds/${superproject}`
    );
    let projectsResults = [];
    for (let index = 0; index < getProjectIds.data.length; index++) {
      let projectId = getProjectIds.data[index].id;
      let projectName = getProjectIds.data[index].project;

      var newData = [];

      var response = await axios.get(
        `${global.config.backendURL}/wbs/getActivities/${subprojectId}/${projectId}`,
        {
          params: {
            sDate: sDate,
            eDate: eDate,
            filterArr: filterArr,
          },
        }
      );

      newData = response.data;
      projectsResults.push({
        projectId: projectId,
        projectName: projectName,
        data: newData,
      });
    }

    dispatch(successWBSActionHelper(projectsResults));
  } catch (error) {
    dispatch(errorActionHelper(error.message));
  }
};
export const getDPRWbs = (sDate, eDate) => async dispatch => {
  dispatch(loadingActionHelper());

  try {
    const subprojectId = global.config.secureStorage.getItem("subprojectId");
    const superproject = global.config.secureStorage.getItem("superproject");

    var getProjectIds = await axios.get(
      `${global.config.backendURL}/wbs/getProjectIds/${superproject}`
    );
    let projectsResults = [];
    for (let index = 0; index < getProjectIds.data.length; index++) {
      let projectId = getProjectIds.data[index].id;
      let projectName = getProjectIds.data[index].project;

      var newData = [];

      var response = await axios.get(
        `${global.config.backendURL}/dpr/mis/${subprojectId}/${projectId}`,
        {
          params: {
            sDate: sDate,
            eDate: eDate,
          },
        }
      );

      newData = response.data;
      projectsResults.push({ projectName: projectName, data: newData });
    }

    dispatch(successWBSActionHelper(projectsResults));
  } catch (error) {
    dispatch(errorActionHelper(error.message));
  }
};

export const getDPRReportBySuperProject = (sDate, eDate) => async dispatch => {
  dispatch(loadingActionHelper());

  try {
    const subprojectId = global.config.secureStorage.getItem("subprojectId");
    const superproject = global.config.secureStorage.getItem("superproject");

    var getProjectIds = await axios.get(
      `${global.config.backendURL}/dpr/getDPRReport/${superproject}`,
      {
        params: {
          sDate: sDate,
          eDate: eDate,
        },
      }
    );
    let projectsResults = getProjectIds.data;
    dispatch(successWBSActionHelper(projectsResults));
  } catch (error) {
    dispatch(errorActionHelper(error.message));
  }
};

export const getMaterialsWbs =
  (sDate, eDate, ReportFormat) => async dispatch => {
    dispatch(loadingActionHelper());

    try {
      // const projectId = global.config.secureStorage.getItem("projectId");
      const subprojectId = global.config.secureStorage.getItem("subprojectId");
      const superproject = global.config.secureStorage.getItem("superproject");

      var getProjectIds = await axios.get(
        `${global.config.backendURL}/wbs/getProjectIds/${superproject}`
      );
      let projectsResults = [];
      for (let index = 0; index < getProjectIds.data.length; index++) {
        let projectId = getProjectIds.data[index].id;
        let projectName = getProjectIds.data[index].project;

        var newData = [];
        var response = await axios.get(
          `${global.config.backendURL}/dpr/materialsReport/${subprojectId}/${projectId}`,
          {
            params: {
              sDate: sDate,
              eDate: eDate,
              ReportFormat: ReportFormat,
            },
          }
        );

        newData = response.data;
        projectsResults.push({ projectName: projectName, data: newData });
      }
      dispatch(successWBSActionHelper(projectsResults));
    } catch (error) {
      dispatch(errorActionHelper(error.message));
    }
  };

export const getLaboursWbs = (sDate, eDate, ReportFormat) => async dispatch => {
  dispatch(loadingActionHelper());

  try {
    const subprojectId = global.config.secureStorage.getItem("subprojectId");
    const superproject = global.config.secureStorage.getItem("superproject");

    var getProjectIds = await axios.get(
      `${global.config.backendURL}/wbs/getProjectIds/${superproject}`
    );
    let projectsResults = [];
    for (let index = 0; index < getProjectIds.data.length; index++) {
      let projectId = getProjectIds.data[index].id;
      let projectName = getProjectIds.data[index].project;

      var newData = [];
      var response = await axios.get(
        `${global.config.backendURL}/dpr/laboursReport/${subprojectId}/${projectId}`,
        {
          params: {
            sDate: sDate,
            eDate: eDate,
            ReportFormat: ReportFormat,
          },
        }
      );

      newData = response.data;
      projectsResults.push({ projectName: projectName, data: newData });
    }

    dispatch(successWBSActionHelper(projectsResults));
  } catch (error) {
    dispatch(errorActionHelper(error.message));
  }
};
export const getcontractorRaWbs =
  (sDate, eDate, ReportFormat) => async dispatch => {
    dispatch(loadingActionHelper());

    try {
      const subprojectId = global.config.secureStorage.getItem("subprojectId");
      const superproject = global.config.secureStorage.getItem("superproject");

      var getProjectIds = await axios.get(
        `${global.config.backendURL}/wbs/getProjectIds/${superproject}`
      );
      let projectsResults = [];
      for (let index = 0; index < getProjectIds.data.length; index++) {
        let projectId = getProjectIds.data[index].id;
        let projectName = getProjectIds.data[index].project;

        var newData = [];

        var response = await axios.get(
          `${global.config.backendURL}/dpr/contractorRaReport/${subprojectId}/${projectId}`,
          {
            params: {
              sDate: sDate,
              eDate: eDate,
              ReportFormat: ReportFormat,
            },
          }
        );

        newData = response.data;
        projectsResults.push({ projectName: projectName, data: newData });
      }

      dispatch(successWBSActionHelper(projectsResults));
    } catch (error) {
      dispatch(errorActionHelper(error.message));
    }
  };
export const getStoreWbs = (sDate, eDate, ReportFormat) => async dispatch => {
  dispatch(loadingActionHelper());

  try {
    const subprojectId = global.config.secureStorage.getItem("subprojectId");
    const superproject = global.config.secureStorage.getItem("superproject");

    var getProjectIds = await axios.get(
      `${global.config.backendURL}/wbs/getProjectIds/${superproject}`
    );
    let projectsResults = [];
    for (let index = 0; index < getProjectIds.data.length; index++) {
      let projectId = getProjectIds.data[index].id;
      let projectName = getProjectIds.data[index].project;

      var newData = [];

      var response = await axios.get(
        `${global.config.backendURL}/wbs/storeReport/${projectId}`,
        {
          params: {
            sDate: sDate,
            eDate: eDate,
          },
        }
      );

      newData = response.data;
      projectsResults.push({ projectName: projectName, data: newData });
    }

    dispatch(successWBSActionHelper(projectsResults));
  } catch (error) {
    dispatch(errorActionHelper(error.message));
  }
};

export const getSupplierWbs =
  (sDate, eDate, ReportFormat) => async dispatch => {
    dispatch(loadingActionHelper());

    try {
      const subprojectId = global.config.secureStorage.getItem("subprojectId");
      const superproject = global.config.secureStorage.getItem("superproject");

      // Get all project IDs first
      const getProjectIds = await axios.get(
        `${global.config.backendURL}/wbs/getProjectIds/${superproject}`
      );

      // Initialize empty arrays for results
      let projectsResults = [];
      let csvData = [];
      let batchSize = 5; // Process 5 projects at a time
      let currentBatch = 0;

      // Process projects in batches
      while (currentBatch * batchSize < getProjectIds.data.length) {
        const batchPromises = [];
        const batchStart = currentBatch * batchSize;
        const batchEnd = Math.min(
          batchStart + batchSize,
          getProjectIds.data.length
        );

        // Create promises for current batch
        for (let index = batchStart; index < batchEnd; index++) {
          const projectId = getProjectIds.data[index].id;
          const projectName = getProjectIds.data[index].project;

          const promise = Promise.all([
            // Get supplier report data
            axios.get(
              `${global.config.backendURL}/dpr/supplierReport/${subprojectId}/${projectId}`,
              {
                params: {
                  sDate: sDate,
                  eDate: eDate,
                  ReportFormat: ReportFormat,
                },
              }
            ),
            // Get CSV data
            axios.get(
              `${global.config.backendURL}/wbs/supplierReportCSV/${subprojectId}/${projectId}`,
              {
                params: {
                  sDate: sDate,
                  eDate: eDate,
                  ReportFormat: ReportFormat,
                },
              }
            ),
          ]).then(([response, responseCSVData]) => {
            if (response.data.length > 0) {
              projectsResults.push({
                projectName: projectName,
                data: response.data,
              });
            }
            const newCsvData = responseCSVData.data.map(item => ({
              ...item,
              projectName,
            }));
            csvData.push(...newCsvData);
          });

          batchPromises.push(promise);
        }

        // Wait for current batch to complete
        await Promise.all(batchPromises);

        // Dispatch update after batch is complete
        dispatch({
          type: SUCCESS_GET_WBS,
          payload: {
            newWbs: [...projectsResults],
            csvData: [...csvData],
          },
        });

        // Add a small delay between batches to prevent UI freezing
        await new Promise(resolve => setTimeout(resolve, 100));

        currentBatch++;
      }
    } catch (error) {
      dispatch(errorActionHelper(error.message));
    }
  };

// export const getSupplierWbs = (sDate, eDate, ReportFormat) => async dispatch => {
//   dispatch(loadingActionHelper());

//   try {
//     const subprojectId = global.config.secureStorage.getItem("subprojectId");
//     const superproject = global.config.secureStorage.getItem("superproject");

//     // Get all project IDs first
//     const getProjectIds = await axios.get(
//       `${global.config.backendURL}/wbs/getProjectIds/${superproject}`
//     );

//     // Initialize empty arrays for results
//     let projectsResults = [];
//     let csvData = [];
//     let batchSize = 5; // Process 5 projects at a time
//     let currentBatch = 0;

//     // Process projects in batches
//     while (currentBatch * batchSize < getProjectIds.data.length) {
//       const batchPromises = [];
//       const batchStart = currentBatch * batchSize;
//       const batchEnd = Math.min(batchStart + batchSize, getProjectIds.data.length);

//       // Create promises for current batch
//       for (let index = batchStart; index < batchEnd; index++) {
//         const projectId = getProjectIds.data[index].id;
//         const projectName = getProjectIds.data[index].project;

//         const promise = Promise.all([
//           // Get supplier report data
//           axios.get(
//             `${global.config.backendURL}/dpr/supplierReport/${subprojectId}/${projectId}`,
//             {
//               params: {
//                 sDate: sDate,
//                 eDate: eDate,
//                 ReportFormat: ReportFormat
//               }
//             }
//           ),
//           // Get CSV data
//           axios.get(
//             `${global.config.backendURL}/wbs/supplierReportCSV/${subprojectId}/${projectId}`,
//             {
//               params: {
//                 sDate: sDate,
//                 eDate: eDate,
//                 ReportFormat: ReportFormat
//               }
//             }
//           )
//         ]).then(([response, responseCSVData]) => {
//           if (response.data.length > 0) {
//             projectsResults.push({ projectName: projectName, data: response.data });
//           }
//           const newCsvData = responseCSVData.data.map(item => ({ ...item, projectName }));
//           csvData.push(...newCsvData);
//         });

//         batchPromises.push(promise);
//       }

//       // Wait for current batch to complete
//       await Promise.all(batchPromises);

//       // Dispatch update after batch is complete
//       dispatch({
//         type: SUCCESS_GET_WBS,
//         payload: {
//           newWbs: [...projectsResults],
//           csvData: [...csvData]
//         },
//       });

//       // Add a small delay between batches to prevent UI freezing
//       await new Promise(resolve => setTimeout(resolve, 100));

//       currentBatch++;
//     }

//   } catch (error) {
//     dispatch(errorActionHelper(error.message));
//   }
// };
